exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-group p {\r\n    padding-left: 10px;\r\n    border-bottom: 1px solid #d2d6de;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/coinconfig/edit-coin/edit-coin.component.css
// module id = ../../../../../src/app/_components/coinconfig/edit-coin/edit-coin.component.css
// module chunks = main